<script>
// Iconsax "arrow-right-2": só o chevron `>`, sem haste. Par do
// `chevron-left` — o "Recolher" do menu sobreposto do índice de artefatos.
export default {
  name: 'ChevronRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.91 20.67C8.72 20.67 8.53 20.6 8.38 20.45C8.09 20.16 8.09 19.68 8.38 19.39L14.9 12.87C15.38 12.39 15.38 11.61 14.9 11.13L8.38 4.61C8.09 4.32 8.09 3.84 8.38 3.55C8.67 3.26 9.15 3.26 9.44 3.55L15.96 10.07C16.47 10.58 16.76 11.27 16.76 12C16.76 12.73 16.48 13.42 15.96 13.93L9.44 20.45C9.29 20.59 9.1 20.67 8.91 20.67Z"
      :fill="color"
    />
  </svg>
</template>
